<template>
  <div class="list-view product-checkout mt-0">
    <b-row class="list-container">
      <!-- <b-col cols="12" v-for="(product, index) in paginatedProducts" :key="index">
        <detail-products :product="product" />
      </b-col> -->
      <b-col cols="12">
        <b-card>
          <!-- {{ productsForCreate }} -->
          <b-table striped hover :items="option == 1 ? productsForCreate : products" :fields="fields">
            <template #cell(total)="data">
              {{ data.item.price * data.item.quantity }}
            </template>
            <template #table-caption>
              <div v-if="!!order && !!order.totalToPayVESTasaConfigurada && !!order.totalToPay"
                class="totalAmountsConcainer" style="color: #605c74;" cols="12">
                <p><b>Total Bs:</b> {{ order.totalToPayVESTasaConfigurada.toFixed(2) }}</p>
                <p><b>Total USD:</b> {{ order.totalToPay.toFixed(2) }}</p>
              </div>
            </template>
          </b-table>
          <!-- <pre>{{ payment }}</pre> -->
          <!-- <pre>{{ order.totalToPayVESTasaConfigurada }}</pre> -->
          <!-- <pre>{{ payment }}</pre>
          <pre>{{ products }}</pre> -->
        </b-card>
      </b-col>
      <!-- <b-col cols="12">
        <b-pagination v-model="page" :total-rows="products.length" :per-page="perPage" first-number align="center"
          last-number prev-class="prev-item" next-class="next-item">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
<template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
</b-pagination>
</b-col> -->
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BPagination, BTable, BCard,
} from 'bootstrap-vue'

import DetailProducts from './DetailProducts.vue'

export default {
  components: {
    BRow,
    BCol,
    BPagination,
    DetailProducts,
    BTable,
    BCard,
  },
  props: {
    option: {
      type: Number,
      default: () => 1,
    },
    blockStatus: {
      type: Boolean,
      default: () => false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    payment: {
      type: Array,
      default: () => [],
    },
    productsForCreate: {
      type: Array,
      default: () => [],
    },
    order: {
      type: Object,
      default: () => { },
    },
  },
  mounted() {
    this.transformData()
  },
  data() {
    return {
      page: 1,
      perPage: 3,
      fields: [{ key: 'name', label: 'Producto' }, { key: 'price', label: 'Precio' }, { key: 'quantity', label: 'Cantidad' }, { key: 'total', label: 'Total' }],
      items: [
        { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
        { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
        { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson' },
        { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
      ]
    }
  },
  computed: {
    paginatedProducts() {
      const startIndex = (this.page - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.products.slice(startIndex, endIndex);
    },
  },
  methods: {
    transformData(a, b) {
      console.log('A', a)
      console.log('B', b)
    },

    calcularAcumuladoAmountVES(pagos, option) {
      if (option == 1) {
        return pagos.reduce((acumulado, pago) => acumulado + pago.amountVES, 0);
      } else {
        return pagos.reduce((acumulado, pago) => acumulado + pago.amount, 0);
      }
    },
  }
}
</script>

<style scoped>
.list-container {
  padding: 8px 0 0 0;
  max-height: 400px;
  /* Altura máxima de la lista, ajusta según sea necesario */
  overflow-y: auto;
  /* Agrega una barra de desplazamiento vertical cuando el contenido es demasiado grande */
}

.totalAmountsConcainer {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
}
</style>